import React, {ComponentType} from "react";
import styles from "./centered-page-container.module.css";
import History from "../../components/about/history/history";
import {Outlet} from "react-router-dom";


const CenteredPageContainer: React.FC<{ component: ComponentType<any> }> = (props) => {




    return (


    <div className={styles.page_rapper}>
        <main className={styles.page_container}>
            {/*<section className={styles.products_content}>*/}
                <props.component/>
            {/*</section>*/}
        </main>
    </div>
)
    ;

}


export default CenteredPageContainer;

